import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { hasAddressOptions } from 'flow/utils/contact-utils';
import { getContactAddressLine } from 'flow/components/contact-card/contact-fields/contact-address-field-utils';

const ContactAddressField = ({
    contact_info_type,
    contact_info_address_data,
}) => {
    if (
        contact_info_type &&
        contact_info_address_data &&
        hasAddressOptions(contact_info_address_data)
    ) {
        const addressLine = getContactAddressLine(
            contact_info_address_data.toJS(),
        );

        return (
            <div className="mx-4 flex grow items-center justify-between rounded-sm p-2 md:flex-row">
                <div className="whitespace-nowrap text-gray-800 md:pe-5">
                    {contact_info_type}
                </div>
                <div className="text-end text-sm text-gray-500">
                    {addressLine}
                </div>
            </div>
        );
    } else {
        return null;
    }
};

ContactAddressField.propTypes = {
    contact_info_address_data: ImmutablePropTypes.mapContains({
        address: PropTypes.string,
        postalcode: PropTypes.string,
        city: PropTypes.string,
    }),
    contact_info_type: PropTypes.string,
};

export default React.memo(ContactAddressField);
